import { render, staticRenderFns } from "./ConcurrentLabelDropdown.vue?vue&type=template&id=03835bcc&scoped=true&"
import script from "./ConcurrentLabelDropdown.vue?vue&type=script&lang=js&"
export * from "./ConcurrentLabelDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ConcurrentLabelDropdown.vue?vue&type=style&index=0&id=03835bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03835bcc",
  null
  
)

export default component.exports